import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import {
  APP_SETTING_LOAD_COLLECTION_SNAPSHOTS_BEGIN,
  APP_SETTING_LOAD_COLLECTION_SNAPSHOTS_SUCCESS,
  APP_SETTING_LOAD_COLLECTION_SNAPSHOTS_FAILURE,
  APP_SETTING_LOAD_COLLECTION_SNAPSHOTS_DISMISS_ERROR,
} from './constants';
import axios from 'axios';

export function loadCollectionSnapshots(args = {}) {
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_LOAD_COLLECTION_SNAPSHOTS_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/collection-snapshots/${projectId}/project`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: APP_SETTING_LOAD_COLLECTION_SNAPSHOTS_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: APP_SETTING_LOAD_COLLECTION_SNAPSHOTS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadCollectionSnapshotsError() {
  return {
    type: APP_SETTING_LOAD_COLLECTION_SNAPSHOTS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_LOAD_COLLECTION_SNAPSHOTS_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        loadCollectionSnapshotsPending: true,
        loadCollectionSnapshotsError: null,
      };

    case APP_SETTING_LOAD_COLLECTION_SNAPSHOTS_SUCCESS:
      // The request is success
      return {
        ...state,
        loadCollectionSnapshotsPending: false,
        loadCollectionSnapshotsError: null,
        collectionSnapshots: action.data,
      };

    case APP_SETTING_LOAD_COLLECTION_SNAPSHOTS_FAILURE:
      // The request is failed
      return {
        ...state,
        loadCollectionSnapshotsPending: false,
        loadCollectionSnapshotsError: action.data.error,
      };

    case APP_SETTING_LOAD_COLLECTION_SNAPSHOTS_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        loadCollectionSnapshotsError: null,
      };

    default:
      return state;
  }
}
